import axios from 'axios';
import { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Accountprice from '../../../../utils/Accountprice';
import { removefreeze, freezrorderstore, getfreeze, getshipping, gettoken, getvoucher, removeToken } from '../../../../Localstorage/Store';

const Vouchersummary = ({ cartInfo, address,count, status, shippingCharges, voucherlist, error }) => {
  const nvg = useNavigate();
  const closeref = useRef(null);
  const openalerthere = useRef(null);
  const freezeid = getfreeze();
  const tokenvalue = gettoken();
  const shippingid = getshipping();
  const localvouhcer = getvoucher();
  const [voucherError, setvoucherError] = useState(null);
  const [notavailable, setnotavailable] = useState(false);
  

    
  const [keyvalue, setkeyvalue] = useState([]);
  const [freezefun,setfreezefun] = useState(false)

  const { bgColor, textColor } = useSelector((state) => state.theam);
  const isShipping = voucherlist[0]?.shipping_incl == false ? "Payable" : voucherlist[0]?.voucher_type == "Gift Voucher - Exclusive" || voucherlist[0]?.voucher_type == "Gift Voucher - Inclusive" ? "Payable" : "Included";
  const isGST = voucherlist[0]?.voucher_type == "Gift Voucher - Exclusive" || voucherlist[0]?.voucher_type == "Shopping Voucher - Exclusive" ? "Payable" : "Included";
  
    const alertb = () => {
    openalerthere.current.click();
    setTimeout(() => {
      closeref.current.click();
    }, 3000);
  };
  
  const getBalancePayable = () => {

    if (isShipping == "Payable" && isGST == "Payable") {
      if (count.taxable_total > count.total_Voucher_Amount) {
        return (count.taxable_total - count.total_Voucher_Amount) + count.gst_total + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip);
      } else {
        return count.gst_total + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip);
      }
    }

    if (isShipping == "Payable" && isGST == "Included") {
      if ((count.taxable_total + count.gst_total) > count.total_Voucher_Amount) {
        return ((count.taxable_total + count.gst_total) - count.total_Voucher_Amount) + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip);
      } else {
        return (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip);
      }
    }

    if (isShipping == "Included" && isGST == "Payable") {
      if ((count.taxable_total + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip)) > count.total_Voucher_Amount) {
        return ((count.taxable_total + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip)) - count.total_Voucher_Amount) + count.gst_total;
      } else {
        return count.gst_total;
      }
    }

    if (isShipping == "Included" && isGST == "Included") {
      if ((count.taxable_total + count.gst_total + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip)) > count.total_Voucher_Amount) {
        return ((count.taxable_total + count.gst_total + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip)) - count.total_Voucher_Amount);
      } else {
        return 0;
      }
    }
  }

  const renderContinueButton = () => {

    if(voucherlist[0]?.voucher_type == "Gift Voucher - Exclusive" || voucherlist[0]?.voucher_type == "Gift Voucher - Inclusive"){
      let totalvalue = count?.taxable_total + count?.gst_total + (shippingCharges?.defaultShip == null ? shippingCharges?.price : shippingCharges?.defaultShip);
      if(totalvalue < count?.total_Voucher_Amount){
        return (
        <button
          style={{
            border: "none",
            outline: "none",
            backgroundColor: `#${bgColor}`,
            padding: "7px 0px",
            color: "white",
            width: "100%",
            fontWeight: 600,
          }}
          type='button'
          onClick={()=>{alertb()}}
        >
          CONFIRM ORDER
        </button>
      );
      }
    }

    // checking is Cart table Empty and any Item is Out Of Stock 
    if (status?.isTableEmpty == 0 || status.outofstock) {
      return (
        <button
          style={{
            border: "none",
            outline: "none",
            backgroundColor: `#${bgColor}`,
            padding: "7px 0px",
            color: "white",
            width: "100%",
            fontWeight: 600,
          }}
        >
          CONFIRM ORDER
        </button>
      );
    }
    // shipping Api error   
    if (shippingCharges.Error == true && shippingCharges.defaultShip == null) {
      return (
        <button
          style={{
            border: "none",
            outline: "none",
            backgroundColor: `#${bgColor}`,
            padding: "7px 0px",
            color: "white",
            width: "100%",
            fontWeight: 600,
          }}
        >
          CONFIRM ORDER
        </button>
      );
    }

    return (
      <button
        style={{
          border: "none",
          outline: "none",
          backgroundColor: `#${bgColor}`,
          padding: "7px 0px",
          color: "white",
          width: "100%",
          fontWeight: 600,
        }}
        onClick={() => { status.setshowbtn(true) }}
      >
        CONFIRM ORDER
      </button>
    );

  }



   const gopaypage = () => { 
   const basketUrl = cartInfo?.cartData?.lines.replace("/lines/", "/");
   const defaultaddress = address.list.filter((item) => item.id == address.default)    
   const shipaddress = shippingid ? address.list.filter((item) => item.id == shippingid) : null;    
   const AmountToPay = getBalancePayable();
   const billingcountry = address.country.filter(
      (item2) => item2.printable_name == defaultaddress[0].country_printable_name.trim()
    );
    const billingcountry2 = address.country.filter(
      (item2) => item2.printable_name == shipaddress?.[0]?.country_printable_name.trim()
    );


   Onlinepay({
    total:AmountToPay,
    checkoutdata:{
      basket:basketUrl,
      guest_email:defaultaddress[0].email,
      code: localvouhcer,
      shipping_address: {
              country: shipaddress == null ? billingcountry[0].url : billingcountry2[0].url,
              first_name: shipaddress == null ? defaultaddress?.[0]?.first_name : shipaddress?.[0]?.first_name,
              last_name: shipaddress == null ? defaultaddress?.[0]?.last_name : shipaddress?.[0]?.last_name,
              line1: shipaddress == null ? defaultaddress?.[0]?.line1 : shipaddress?.[0]?.line1,
              line2: shipaddress == null ? defaultaddress?.[0]?.line2 : shipaddress?.[0]?.line2,
              line3: "",
              line4: shipaddress == null ? defaultaddress?.[0]?.line4 : shipaddress?.[0]?.line4,
              notes: "",
              phone_number: shipaddress == null ? defaultaddress?.[0]?.phone_number : shipaddress?.[0]?.phone_number,
              postcode: shipaddress == null ? defaultaddress?.[0]?.postcode : shipaddress?.[0]?.postcode,
              state: shipaddress == null ? defaultaddress?.[0]?.state : shipaddress?.[0]?.state,
              email: shipaddress == null ? defaultaddress?.[0]?.email : shipaddress?.[0]?.email,
            },
      billing_address: {
              country: billingcountry[0].url,
              first_name: defaultaddress[0].first_name,
              last_name: defaultaddress[0].last_name,
              line1: defaultaddress[0].line1,
              line2: defaultaddress[0].line2,
              line3: "",
              line4: defaultaddress[0].line4,
              notes: "",
              phone_number: defaultaddress[0].phone_number,
              postcode: defaultaddress[0].postcode,
              state: defaultaddress[0].state,
              email: defaultaddress[0].email,
            },
    }
  });
   
  };



  const Onlinepay = async (state) => {

      const formdata = new FormData()
      formdata.append('code',localvouhcer)
      let url3 = `${process.env.REACT_APP_API_URL}homepageapi/already-used-voucher-code/`;
      const response2 = await axios.post(url3, formdata);
      if(response2.data.message == `This code (${localvouhcer}) is valid.`){
        const userinfo = state.checkoutdata;
        const ids = await fetchstatus()
        var options = {
          key: process.env.REACT_APP_PAYMENT_KEY,
          key_secret: process.env.REACT_APP_PAYMENT_KEY_SECRET,
          amount: Number(parseFloat(state.total) * 100).toFixed(0),
          currency: "INR",
          order_receipt: "order_rcptid_" + userinfo.shipping_address.first_name,
          name: "OneUpShop",
          description: "for testing purpose",
          handler: async function (response) {
                    const paymentId = response.razorpay_payment_id;
                    const orderInfo = {
                  shipping_address:userinfo.shipping_address,
                  billing_address:userinfo.billing_address,
                    date: new Date().toLocaleString("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                    }),
                    email: userinfo.guest_email,
                    basket: userinfo.basket,
                    payment_id: paymentId,
                    status: "ACCEPTED",
                    shipping_method_code: "no-shipping-required",
                    payment_types: "razorpay",
                    total_amount: parseFloat(state.total),
                    code: localvouhcer,
                  };
                
    
            try {
             await unfreezestatus(freezeid,keyvalue,ids)
              thankyoupage(orderInfo);
            } catch (error) {}
          },
    
          theme: {
            color: `#${bgColor}`,
          },
          modal: {
            ondismiss: function () {
                setTimeout(() => {
                  unfreezestatus(freezeid,keyvalue,ids)
                }, 2000);
            }
        },
        };
    
        var pay = new window.Razorpay(options);
        pay.open();
      }else{
        setvoucherError("This Voucher has already been used")
      }
  
  };



  const thankyoupage = async (orderinfo) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      let url = `${process.env.REACT_APP_API_URL}my_api/checkout/`;
      const response = await axios.post(url, orderinfo, config);
      if (response.data.number) {
          removeToken();
          nvg("/thankyoupagelogin", {
            state: {
              orderid: response.data.number
            },
          });
        
      }

    } catch (error) {
if(error.response.data.detail == "This coupon has already been used"){
}

    }
  }; 




  const fetchstatus = async () => {
      if(freezefun == false){
        setfreezefun(true)
        const config = {
          headers: {
            Authorization: `Bearer ${tokenvalue.access}`,
          },
        };
        let url = `${process.env.REACT_APP_API_URL}my_api/freeze-stock/`;
    
        const response = await axios.get(url, config);
        freezrorderstore(response.data.freeze_ids)
        setkeyvalue(response.data.freeze_ids)
        setfreezefun(false)
        return response.data.freeze_ids;
      }
      
  
    }

    
  const unfreezestatus = async (freezeid,keyvalue,ids) => {
    if(freezeid || keyvalue.length > 0 || ids){
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      const formdata = {freeze_id_list:freezeid ? freezeid : ids};
      let url = `${process.env.REACT_APP_API_URL}my_api/unfreeze-stock/`;
  
      const response = await axios.post(url,formdata, config);
      removefreeze()

    }
  }  





  return (
    <>
      <div
        className="py-2 px-2"
        style={{ background: "#ffff", borderRadius: 6 }}
      >
        <h4
          style={{
            padding: "0px 14px",
            fontWeight: 700,
          }}
          className="titlesizes"

        >
          Payment Summary
        </h4>
        <div
          className="firstrow px-3 d-flex justify-content-between"
          style={{ padding: "5px 0px" }}
        >
          <span
            className="family"
            style={{ fontWeight: 600, fontSize: "12px" }}
          >

            {`Taxable Amount(${count.totalqty} Item(s))`}
          </span>
          <span
            className="family"
            style={{
              fontWeight: 500,
              color: `#${bgColor}`,
              fontSize: "12px",
            }}
          >
            {count.taxable_total == 0 ? `₹0` : Accountprice((count.taxable_total).toFixed(0))}
          </span>
        </div>
        <div
          className="firstrow px-3 d-flex justify-content-between"
          style={{ padding: "5px 0px" }}
        >
          <span
            className="family"
            style={{ fontWeight: 600, fontSize: "12px" }}
          >
            GST Amount
          </span>
          <span
            className="family"
            style={{
              fontWeight: 500,
              color: `#${bgColor}`,
              fontSize: "12px",
            }}
          >
            {count.gst_total > 0 ? `+${Accountprice(count.gst_total)}` : `₹0`}
          </span>
        </div>
        <div
          className="firstrow px-3 d-flex justify-content-between"
          style={{ padding: "5px 0px" }}
        >
          <span
            className="family"
            style={{ fontWeight: 600, fontSize: "12px" }}
          >
            Shipping Charges

          </span>
          <span
            className="family"
            style={{
              fontWeight: 500,
              color: `#${bgColor}`,
              fontSize: "12px",
            }}
          >
            {status?.isTableEmpty == 0 ? `₹0` : shippingCharges.defaultShip == null ? `+${Accountprice(shippingCharges.price)}` : `+${Accountprice(shippingCharges.defaultShip)}`}
          </span>
        </div>

        <div
          className="firstrow px-3 "
          style={{
            padding: "5px 0px",
          }}
        >
          <div className="justify-content-between" style={{ display: 'flex' }}>
            <span
              className="family"
              style={{ fontWeight: 600, fontSize: "12px" }}
            >
              Total Amount

            </span>
            <span
              className="family"
              style={{
                fontWeight: 500,
                color: `#${bgColor}`,
                fontSize: "12px",
              }}
            >
              {status?.isTableEmpty == 0 ? `₹0` : Accountprice(count.taxable_total + count.gst_total + (shippingCharges.defaultShip == null ? shippingCharges.price : shippingCharges.defaultShip))}

            </span>
          </div>
        </div>


        <div className="firstrow px-3 d-flex justify-content-between" style={{ padding: "5px 0px" }}    >
          <span className="family" style={{ fontWeight: 600, fontSize: "12px" }}  >
            {voucherlist[0]?.voucher_type == "Gift Voucher - Inclusive" || voucherlist[0]?.voucher_type == "Gift Voucher - Exclusive"
              ? "Voucher Applied"
              : "Voucher Redeem"}
          </span>
          <span
            className="family"
            style={{
              fontWeight: 500,
              color: `#${bgColor}`, fontSize: "12px",
            }}
          >
            {status?.isTableEmpty == 0 ? `₹0` : `-${Accountprice(count.total_Voucher_Amount)}`}
          </span>
        </div>

        <div className="firstrow px-3 pt-1 d-flex justify-content-between">
          <span
            style={{
              fontWeight: 600,
              fontSize: "12px",
              paddingLeft: "0px",
            }}
          >

            {voucherlist[0]?.voucher_type == "Gift Voucher - Inclusive" || voucherlist[0]?.voucher_type ==
              "Gift Voucher - Exclusive"
              ? "Amount Payable"
              : "Balance Payable"}

          </span>
          <span
            style={{
              fontWeight: 500,
              color: `#${bgColor}`,
              fontSize: "12px",
            }}
          >

            {status?.isTableEmpty == 0 ? `₹0` : Accountprice(getBalancePayable())}
          </span>


        </div>

        <div className="px-3" style={{ gap: '1px' }} >
          <div
            className="firstrow  d-flex justify-content-between"
            style={{ padding: "5px 0px", width: '100%' }}
          >
            {renderContinueButton()}

          </div>

        </div>





        {status.showbtn != true ? '' : <div className="firstrow px-3 d-flex justify-content-between"
          style={{ padding: "5px 0px", paddingLeft: "20px" }}>


          <div

            style={{ width: "100%", display: 'flex', gap: '10px' }}
          >
            <button
              style={{
                border: "none",
                outline: "none",
                border: `1px solid #${bgColor}`,
                padding: "7px 0px",
                color: `#${bgColor}`,
                width: "100%",
                fontWeight: 600,
              }}
            >
              Pay Online
            </button>


            <button

              style={{
                border: "none",
                outline: "none",
                border: "1px solid #393737",
                padding: "7px 0px",
                color: notavailable ? "red" : "#393737",
                width: "100%",
                fontWeight: 600,
              }}
              onMouseEnter={() => { setnotavailable(true) }}
              onMouseLeave={() => { setnotavailable(false) }}
            >
              {notavailable == true ? "Not Available" : "Cash on Delivery "}
            </button>
          </div>

        </div>}






        {status.showbtn != true ? '' : <div className="firstrow px-3 d-flex justify-content-between"
          style={{ padding: "5px 0px", paddingLeft: "20px" }}>


          <div style={{ width: "100%", display: 'flex', gap: '10px' }} >
            <button
                onClick={() => {gopaypage();}}
              style={{
                border: "none",
                outline: "none",
                background: `#${bgColor}`,
                padding: "7px 0px",
                color: "#fff",
                width: "100%",
                fontWeight: 600,
              }}
            >
              PAY
              &nbsp;
              <span
                style={{
                  fontWeight: 500,
                  color: "#fff",
                  display: ''
                }}
              >
                {Accountprice(getBalancePayable())}

                <br />
              </span>
            </button>
          </div>

        </div>}



   {shippingCharges.Error == true && shippingCharges.defaultShip == null && <div className="firstrow px-2 pb-2 d-flex justify-content-between">
          <p
            style={{
              color: "red",
              display: "block",
              width:'100%',
              textAlign:'center'
            }}
          >
            Courier Service Not Avilabile
          </p>
        </div>}

        <div
          className="firstrow px-3 d-flex justify-content-between"
          style={{ padding: "5px 0px", paddingLeft: "20px" }}
        >
          <span
            style={{
              color: "red",
              fontSize: "12px",
              fontWeight: "500",
              width: "100%",
              textAlign: "center",
            }}
          >
            {voucherError}
          </span>
        </div>

















      </div>































      {/* pop up box starting from here  */}


      {/* <div
        className="modal fade"
        id="exampleModaShippingError"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header mod-line d-none"></div>
            <div className="modal-body">
              <div className="row gy-3 mt-2">
                <h4
                  style={{
                    color: `#${textColor}`,
                    cursor: "pointer",
                    textAlign: "center",
                    fontSize: "21px",
                    fontWeight: "800",
                  }}
                >
                  Shipping Alert
                </h4>
                <p
                  className="ccedit-p "
                  style={{ textAlign: "center", fontSize: "13px" }}
                >
                  courier Service not avilabile
                </p>
              </div>
            </div>
            <div
              className="modal-footer mod-line m-auto"
              style={{ border: "none" }}
            >
              <button
                type="button"
                className="btn closebtn "
                style={{
                  paddingRight: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: `#${textColor}`,
                }}
                data-bs-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
        </div>
      </div> */}



           {/* pop box start here  */}


      <div style={{
        overflow: "hidden",
        width: "5%",
        position: "relative",
      }}
      >
        <button
          ref={openalerthere}
          type="button"
          style={{
            fontSize: "12px",
            position: "absolute",
            left: "400px",
          }}
          data-bs-toggle="modal"
          data-bs-target="#vouchererroraboveprice"
          class="dropdown-item"
        >
        </button>
      </div>

      <div
        className="modal fade"
        id="vouchererroraboveprice"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <div className="modal-content centercontentofalert" style={{ backgroundColor: `#${bgColor}` }}>
            <div className="modal-header mod-line d-none"></div>
            <div className="modal-body" style={{ padding: "0px" }}>
              <div className="row">
                <p
                  className="ccedit-p "
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    backgroundColor: `#${bgColor}`,
                    color: "white",
                    fontWeight: "550",
                  }}
                >
                 Cart Amount Must be Higher Than Voucher Amount
                </p>
              </div>
            </div>
            <div
              className="modal-footer mod-line m-auto"
              style={{
                border: "none",
                position: "absolute",
                left: "389px",
              }}
            >
        
              <button
                type="button"
                className="btn closebtn "
                style={{
                  paddingRight: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#230BB3",
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeref}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* pop end here  */}

    </>
  )
}

export default Vouchersummary